import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UploadUserGroupsButton from "./components/userGroups/UploadUserGroupsButton";
import UserGroupsList from "./components/userGroups/UserGroupsList";
import UserGroupDetails from "./components/userGroups/UserGroupDetails";
import { UserGroupIcon } from "@/assets/icons";
import { Stack, Typography } from "@altimateai/lego";
import useUserGroups from "./components/userGroups/useUserGroups";
import { useBreadcrumb } from "@/components/breadcrumbs";

const UserGroups = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { groups, isLoading } = useUserGroups();

  useBreadcrumb("Teams", {
    defaultParents: [{ label: "Settings", pathname: "/settings", noLink: true }],
    truncateTo: "/settings",
  });

  // Auto-select first team if no team is selected and at least one team exists
  useEffect(() => {
    if (!id && !isLoading && groups.length > 0) {
      navigate(`/usergroups/${groups[0].id}`, { replace: true });
    }
  }, [id, isLoading, groups, navigate]);

  return (
    <div role="region" aria-label="Teams Management">
      <Stack justify="between">
        <Stack direction="row" align="center" gap="sm" className="al-flex-1 al-m-0">
          <UserGroupIcon aria-hidden="true" />
          <Typography variant="page-heading" className="al-m-0">
            Teams
          </Typography>
        </Stack>
        <UploadUserGroupsButton />
      </Stack>
      <Stack className="al-mt-2">
        <UserGroupsList />
        <main aria-label="Team Details" className="al-flex-1">
          <UserGroupDetails />
        </main>
      </Stack>
    </div>
  );
};

export default UserGroups;
